import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import * as qs from 'query-string';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { ModalService } from '../../../../../../coverpath-common/angular/services/modal/modal.service';
import { ModalType } from '../../../../../../coverpath-common/js/interfaces/CoverpathTypes';
import { Controller } from '../../../Controller';

const ssnFourDigits = (control: AbstractControl) => {
  const { value } = control;
  // this regex tests whether the given value is 4 digits (less/more than 4 and/or alphanumeric will fail)
  if (/^\d{4}$/.test(value)) {
    return null;
  } else {
    return {
      ssnLastFour: {
        message: '4 digits required.',
      },
    };
  }
};

const required = (control: AbstractControl) => {
  const res = Validators.required(control);
  if (res) {
    return {
      required: {
        message: 'Required',
      },
    };
  }
  return null;
};

@Component({
  moduleId: module.id,
  selector: 'additional-esign',
  templateUrl: './additional-esign.component.html',
})
export class AdditionalEsignComponent implements OnInit {
  controller: Controller;
  modalService: ModalService;
  group: FormGroup;
  loadingScreen = true;
  jwtToken: string;
  esignCompleted = false;
  unauthorized = false;
  attemptsRemaining: number;

  constructor(amorphicService: AmorphicService, modalService: ModalService) {
    this.controller = amorphicService.controller as Controller;
    this.modalService = modalService;
  }

  async ngOnInit() {
    this.group = new FormGroup({
      ssnLastFour: new FormControl('', { updateOn: 'change', validators: [required, ssnFourDigits] }),
    });

    this.jwtToken = qs.parse(location.search).jwtToken as string;
    this.loadingScreen = false;
  }

  async submit({ ssnLastFour }) {
    this.loadingScreen = true;
    try {
      const { valid, attemptsRemaining, signerValidatedToken } = await this.controller.authenticateSigner(
        this.jwtToken,
        ssnLastFour
      );
      if (!valid) {
        this.attemptsRemaining = attemptsRemaining;
        this.unauthorized = true;
        return;
      }
      this.unauthorized = false;
      const formsToSign = await this.controller.setupAnnuityDocumentsForAdditionalEsign(signerValidatedToken);
      const modalConfig = {
        type: ModalType.esignModal,
        formsToSign: formsToSign.map((form) => {
          const signFn = form.isSignatureRequired
            ? () => this.controller.markEsignComplete(signerValidatedToken, form.appType)
            : () => {};
          return {
            ...form,
            signFn,
          };
        }),
        onFinishSigning: async () => {
          await this.controller.onAnnuityAdditionalEsignComplete(signerValidatedToken);
          this.esignCompleted = true;
        },
      };
      this.modalService.activate(modalConfig);
    } finally {
      this.loadingScreen = false;
    }
  }

  close(): void {
    window.close();
  }
}
